import { useTranslation } from 'next-i18next'
import React, { useState } from 'react'

import s from './landing.module.css'

const VIDEO_ID = 'UsN3qIkeEWo'
const YOUTUBE_CHANNEL = 'https://www.youtube.com/@goodfellasapp'
const INSTAGRAM = 'https://www.instagram.com/goodfellasapp/'

/**
 * Trailer click-to-play: pôster (thumbnail do YouTube) até o clique, então o
 * iframe nocookie com autoplay — evita erro de embed em origens restritas e
 * só instancia o player mediante gesto do usuário.
 */
export function Trailer() {
  const { t } = useTranslation('landing')
  const [playing, setPlaying] = useState(false)

  return (
    <section
      className={`bg-section-black ${s.sec}`}
      id="trailer"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <div
        className={s.ghost}
        style={{
          fontSize: 'clamp(160px,24vw,420px)',
          insetInlineEnd: '-4%',
          top: -30,
        }}
        aria-hidden="true"
      >
        4
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 24,
          alignItems: 'flex-end',
          position: 'relative',
        }}
      >
        <div>
          <p className={`${s.kick} text-brand`}>
            <span className={s.kbar} />
            {t('trailer.kicker')}
          </p>
          <h2
            className={`${s.d} ${s.h2} text-white`}
            style={{ margin: '22px 0 0' }}
          >
            {t('trailer.title1')}
            <br />
            <span className={s.outW}>{t('trailer.title2')}</span>
          </h2>
        </div>
        <p
          className={s.lead}
          style={{ maxWidth: 440, color: 'rgba(255,255,255,.85)' }}
        >
          {t('trailer.lead')}
        </p>
      </div>

      <div className={s.ytwrap}>
        {playing ? (
          <iframe
            src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
            title={t('trailer.iframeTitle')}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              border: 0,
            }}
          />
        ) : (
          <button
            className={s.posterBtn}
            onClick={() => setPlaying(true)}
            aria-label={t('trailer.playAria')}
          >
            {/* Thumbnail vem do YouTube: se a capa do vídeo mudar lá, o pôster
                atualiza sozinho. */}
            <img
              src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
              alt={t('trailer.posterAlt')}
              loading="lazy"
              onError={(e) => {
                e.currentTarget.src = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`
              }}
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.82,
              }}
            />
            <span
              style={{
                position: 'absolute',
                inset: 0,
                background:
                  'linear-gradient(180deg,rgba(0,0,0,.1),rgba(0,0,0,.45))',
              }}
            />
            <span className={s.playBig}>
              <span style={{ color: '#fff', fontSize: 30, marginLeft: 5 }}>
                ▶
              </span>
            </span>
            <span
              className={`${s.cond} text-white`}
              style={{
                position: 'absolute',
                bottom: 26,
                insetInlineStart: 30,
                fontSize: 15,
                fontWeight: 700,
                letterSpacing: '.18em',
              }}
            >
              {t('trailer.caption')}
            </span>
          </button>
        )}
      </div>
    </section>
  )
}

/** Podcasts e Lutas + barra do Instagram — continua no preto do trailer. */
export function MediaSection() {
  const { t } = useTranslation('landing')

  return (
    <section
      className="bg-section-black"
      id="podcasts"
      style={{ padding: '0 7vw 110px' }}
    >
      <div
        style={{
          borderTop: '2px solid rgba(255,255,255,.14)',
          paddingTop: 80,
        }}
      >
        <p className={`${s.kick} text-brand`}>
          <span className={s.kbar} />
          {t('media.kicker')}
        </p>
        <h2
          className={`${s.d} ${s.h2} text-white`}
          style={{ margin: '22px 0 0' }}
        >
          {t('media.title1')}
          <br />
          <span className={s.outW}>{t('media.title2')}</span>
        </h2>
        <p
          className={s.lead}
          style={{ marginTop: 16, color: 'rgba(255,255,255,.85)' }}
        >
          {t('media.lead')}
        </p>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
            gap: 20,
            marginTop: 44,
          }}
        >
          <a
            className={s.mediacard}
            href={YOUTUBE_CHANNEL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={s.stag}>YouTube · @goodfellasapp</div>
            <div
              className={s.d}
              style={{
                fontSize: 'clamp(44px,4.4vw,68px)',
                margin: '12px 0 6px',
                color: '#fff',
              }}
            >
              {t('media.podcastsTitle')}
            </div>
            <p className={s.fp} style={{ color: 'rgba(255,255,255,.75)' }}>
              {t('media.podcastsCopy')}
            </p>
            <div className={s.playrow}>
              <span className={s.play}>▶</span>
              {t('media.watchNow')}
            </div>
          </a>

          <a
            className={s.mediacard}
            href={YOUTUBE_CHANNEL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ borderColor: '#EC1B2E' }}
          >
            <div className={s.stag}>YouTube · @goodfellasapp</div>
            <div
              className={s.d}
              style={{
                fontSize: 'clamp(44px,4.4vw,68px)',
                margin: '12px 0 6px',
                color: '#fff',
              }}
            >
              {t('media.fightsTitle')}
            </div>
            <p className={s.fp} style={{ color: 'rgba(255,255,255,.75)' }}>
              {t('media.fightsCopy')}
            </p>
            <div className={s.playrow}>
              <span className={s.play}>▶</span>
              {t('media.watchNow')}
            </div>
          </a>
        </div>

        <a
          className={s.igbar}
          href={INSTAGRAM}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={s.stag}>Instagram · @goodfellasapp</span>
          <span
            className={s.cond}
            style={{ fontWeight: 700, fontSize: 16, letterSpacing: '.1em' }}
          >
            {t('media.igCopy')}
          </span>
          <span className={s.playrow} style={{ marginTop: 0 }}>
            {t('media.follow')}
          </span>
        </a>
      </div>
    </section>
  )
}
